/*
 * @Author: Teemo Ding
 * @Date: 2021-06-30 09:10:55
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-30 16:21:16
 * @FilePath: /unifyxp-v2-store-portal/src/request/salesChannel/setting/invoice.ts
 */
import { post, get } from 'src/tools/server';

export const request_invoiceData = (salesChannelUuid: string) => {
  return get<any>(
    `/portal/setting/salesChannel/invoice/${salesChannelUuid}`,
    {},
  );
};

export const save_invoiceData = (salesChannelUuid: string, data) => {
  return post<any>(
    `/portal/setting/salesChannel/invoice/${salesChannelUuid}`,
    data,
    {},
  );
};
